import { render, staticRenderFns } from "./EvaluationsList.vue?vue&type=template&id=4dbe83b8"
import script from "./EvaluationsList.vue?vue&type=script&lang=js"
export * from "./EvaluationsList.vue?vue&type=script&lang=js"
import style0 from "./EvaluationsList.vue?vue&type=style&index=0&id=4dbe83b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports